import React from "react";
import "./style.scss"

const SplashScreen = (props) => {
    return (
        <div className="preloader flex-column justify-content-center align-items-center">
            <img className="animated shake" src={process.env.PUBLIC_URL + '/logo-beelajar.png'}
                alt="Loading..." />
            {props.message && <div className="mt-2">Waiting to logout...</div>}
        </div>
    );
};

export default SplashScreen;
